export const parseOrderAdjustmentValue = (value) => {
  const parsed = parseFloat(
    String(value || 0)
      .replace(/\./g, "")
      .replace(",", "."),
  );

  return Number.isFinite(parsed) ? parsed : 0;
};

export const calculateOrderAdjustmentAmount = (baseAmount, adjustment) => {
  const value = parseOrderAdjustmentValue(adjustment && adjustment.value);
  if (!value) return 0;

  if (adjustment.type === "percent") {
    return Math.round((Math.max(0, Number(baseAmount) || 0) * value) / 100);
  }

  return Math.round(value);
};

export const getPostDiscountSubtotal = (subtotal, discountAmount) =>
  Math.max(0, (Number(subtotal) || 0) - (Number(discountAmount) || 0));

export const getFeeApplicationBase = (
  subtotal,
  postDiscountSubtotal,
  applyOn = "after_discount",
) =>
  applyOn === "subtotal"
    ? Math.max(0, Number(subtotal) || 0)
    : Math.max(0, Number(postDiscountSubtotal) || 0);
